<script>
	// libraries
	import { LayerCake, ScaledSvg, Html } from "layercake";
	import { scaleOrdinal, scaleTime, scalePow } from "d3-scale";

	// components
	import AxisX from "./AxisX.svelte";
	import MultiLine from "./MultiLine.svelte";

	// other
	import { formatYear, formatOnlyMonth } from "../utils";

	// ///////////////////////////////////////////////////////////
	// properties
	// ///////////////////////////////////////////////////////////
	export let data;
	export let xKey = "date";
	export let yKey = "value";
	export let yMin = null;
	export let yMax = null;
	export let variables = Object.keys(data[0]).filter((d) => d !== xKey);
	export let colors = ["#ffe4b8", "#ffb3c0", "#ff7ac7", "#ff00cc"];
	export let strokeWidth = 2;

	// ///////////////////////////////////////////////////////////
	// constants and definitions
	// ///////////////////////////////////////////////////////////

	// ///////////////////////////////////////////////////////////
	// Set what is our x key to separate it from the other series
	// ///////////////////////////////////////////////////////////
	const zKey = "variable";

	const seriesNames = variables;
	const seriesColors = colors;

	// ///////////////////////////////////////////////////////////
	// Create a "long" format that is a grouped series of data points
	// Layer Cake uses this data structure and the key names
	// set in xKey, yKey and zKey to map your data into each scale.
	// ///////////////////////////////////////////////////////////
	const dataLong = seriesNames.map((key) => {
		return {
			[zKey]: key,
			values: data.map((d) => {
				d[xKey] = typeof d[xKey] === "string" ? Date.parse(d[xKey]) : d[xKey]; // Conditional required for sapper
				return {
					[yKey]: +d[key],
					[xKey]: d[xKey],
					[zKey]: key,
				};
			}),
		};
	});

	// ///////////////////////////////////////////////////////////
	// Make a flat array of the `values` of our nested series
	// we can pluck the field set from `yKey` from each item
	// in the array to measure the full extents
	// ///////////////////////////////////////////////////////////
	const flatten = (data) =>
		data.reduce((memo, group) => {
			return memo.concat(group.values);
		}, []);

	// yScale={scalePow().exponent(0.5)}
</script>

<LayerCake
	ssr={true}
	percentRange={true}
	padding={{ top: 0, right: 0, bottom: 0, left: 0 }}
	x={xKey}
	y={yKey}
	z={zKey}
	xScale={scaleTime()}
	zScale={scaleOrdinal()}
	zDomain={seriesNames}
	zRange={seriesColors}
	yDomain={[yMin, yMax]}
	flatData={flatten(dataLong)}
	data={dataLong}
>
	<Html>
		<AxisX
			gridlines={false}
			baseline={true}
			tickMarks={false}
			ticks={false}
			baselineColor="#D4D4D580"
			baselineWidth="1"
			baselineStyle="solid"
		/>
	</Html>

	<ScaledSvg>
		<MultiLine {strokeWidth} smooth={false} roundToInt={true} />
	</ScaledSvg>
</LayerCake>

<style lang="scss">
</style>
